import { Box, styled } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

export const ChartCardContainer = styled(Box)(() => ({
  "& .MuiCardHeader-content": { maxWidth: "100%" }
}));

export const ChartCardHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
  alignItems: "center",
  color: theme.palette.primary.main,
  fontWeight: theme.typography.fontWeightBold,
  fontSize: "18px"
}));

export const ChartRefreshIcon = styled(RefreshIcon)(() => ({
  width: "22px",
  height: "22px"
}));
